interface CustomerServiceProps {
  onClose: () => void;
}

const CustomerService = ({ onClose }: CustomerServiceProps) => {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: '电话咨询',
      content: '023-12345678',
      description: '工作时间：9:00-18:00',
      action: 'tel:02312345678'
    },
    {
      icon: 'ri-wechat-line',
      title: '微信咨询',
      content: 'didijihua2024',
      description: '扫码添加客服微信',
      action: ''
    },
    {
      icon: 'ri-mail-line',
      title: '邮箱咨询',
      content: 'service@didijihua.org',
      description: '我们会在24小时内回复',
      action: 'mailto:service@didijihua.org'
    }
  ];

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/50 z-50 animate-[fadeIn_0.3s_ease-out]"
        onClick={onClose}
      ></div>

      {/* Dialog */}
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-2xl bg-white rounded-2xl shadow-2xl z-50 animate-[slideUp_0.3s_ease-out] max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-[#2A7A62] to-[#3A9A82] text-white px-8 py-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                <i className="ri-customer-service-2-fill text-2xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold">客服支持</h3>
                <p className="text-sm text-white/80 mt-1">我们随时为您提供帮助</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {contactMethods.map((method, index) => (
              <div
                key={index}
                className="bg-[#F9F9F9] rounded-xl p-6 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-full flex items-center justify-center mb-4">
                  <i className={`${method.icon} text-white text-2xl`}></i>
                </div>
                <h4 className="text-lg font-bold text-[#1E1E1E] mb-2">{method.title}</h4>
                <p className="text-base font-medium text-[#2A7A62] mb-2">{method.content}</p>
                <p className="text-sm text-[#6C6C6C] mb-4">{method.description}</p>
                {method.action && (
                  <a
                    href={method.action}
                    className="inline-block text-sm text-[#2A7A62] font-medium hover:underline cursor-pointer"
                  >
                    立即联系 <i className="ri-arrow-right-line"></i>
                  </a>
                )}
              </div>
            ))}
          </div>

          {/* FAQ Section */}
          <div className="bg-[#F9F9F9] rounded-xl p-6">
            <h4 className="text-lg font-bold text-[#1E1E1E] mb-4 flex items-center gap-2">
              <i className="ri-question-line text-[#2A7A62]"></i>
              常见问题
            </h4>
            <div className="space-y-3">
              <div className="bg-white rounded-lg p-4">
                <p className="font-medium text-[#1E1E1E] mb-1">Q: 申请需要多长时间审核？</p>
                <p className="text-sm text-[#6C6C6C]">A: 通常3-5个工作日内完成审核，审核结果会通过短信或电话通知。</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <p className="font-medium text-[#1E1E1E] mb-1">Q: 需要准备哪些材料？</p>
                <p className="text-sm text-[#6C6C6C]">A: 需要提供工作证、工作照片或单位证明等能证明您身份的材料。</p>
              </div>
              <div className="bg-white rounded-lg p-4">
                <p className="font-medium text-[#1E1E1E] mb-1">Q: 审核不通过怎么办？</p>
                <p className="text-sm text-[#6C6C6C]">A: 我们会说明原因，您可以补充材料后重新申请。</p>
              </div>
            </div>
          </div>

          {/* Working Hours */}
          <div className="mt-6 bg-[#FFF9E6] border border-[#F4B942] rounded-lg p-4">
            <p className="text-sm text-[#1E1E1E]">
              <i className="ri-time-line text-[#F4B942] mr-2"></i>
              <strong>客服工作时间：</strong>周一至周五 9:00-18:00（节假日除外）
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerService;